import React from "react";
import "./App.css";
import { useGlobalStates } from "./context/GlobalProvider";
import AlertSuccess from "./components/AlertSuccess";
import AlertError from "./components/AlertError";
import Footer from "./components/Footer";
import Home from "./components/Home";

const App = () => {
  // Hello World
  const { alert, alertMsg } = useGlobalStates();
  return (
    <>
      <div className="w-screen bg-gray-600 h-screen flex justify-center">
        <Home />
        <Footer />
      </div>

      {alert && (
        <>
          {alert === "success" ? (
            <AlertSuccess msg={alertMsg} />
          ) : (
            <AlertError msg={alertMsg} />
          )}
        </>
      )}
    </>
  );
};

export default App;
